export default [
  {
    path: '/outils/bibliotheque-mails',
    name: 'bibliotheque-mails',
    component: () => import('@/views/outils/gestion-messageries/BibliothequeMail.vue'),
  },

  {
    path: '/outils/annuaire',
    name: 'annuaire',
    component: () => import('@/views/outils/annuaire/MasterAnnuaire.vue'),
  },
  {
    path: '/outils/procedure',
    name: 'modele-procedure',
    component: () => import('@/views/Prochainement.vue'),
  },
  {
    path: '/outils/guide',
    name: 'guide',
    component: () => import('@/views/outils/guide/MasterGuide.vue'),
  },
]
